import { CreateNS } from '../lib/createAPIBuilder';

export const installAPINative = (namespace: CreateNS) => {
    namespace('native')(({ func, prop, deps }) => {
        prop('isNative', deps.native.isNative, null);
        prop('appName', deps.native.appName, null);
        func('messageToWeb', deps.native.messageToWeb);
        func('messageToNative', deps.native.messageToNative);
    });
};

export const installAtNativeSession = (namespace: CreateNS) => {
    namespace('nativeSession')(({ func, prop, deps }) => {
        prop('isActive', deps.isNativeSession, null);
        prop('sessionParams', deps.sessionParams, null);
        func('backToApp', deps.backToApp);
        func('setNativeSession', deps.setNativeSession);
    });
};
